import React from 'react'
import { connect } from 'react-redux'
import RCSlider from 'rc-slider'

import QV from 'components/Quote/QuoteValue'
import {
  getQuoteValue,
  getBestPayment,
  getPaymentSliderMarkers,
  getPaymentRange,
} from 'selectors/quoteSelectors'

import { updateQuoteSlider } from 'actions/quoteActions'

import 'rc-slider/assets/index.css'
import './Slider.scss'

export class Slider extends React.Component {
  constructor(...args) {
    super(...args)

    this.state = {
      sliderVal: this.props.desiredPayment || this.props.startingPayment,
      paymentRange: this.props.paymentRange,
    }
    this.setDragging = isDragging => this.setState({ isDragging })

    this.updateSliderVal = sliderVal => this.setState({ sliderVal })

    this.updateAppState = v => {
      this.props.updateQuoteSlider(
        this.props.vehicleId,
        this.props.quoteId,
        v,
        false,
      )
      this.props.onChange()
    }
  }

  componentDidUpdate(oldProps) {
    let { startingPayment } = this.props

    if (startingPayment !== oldProps.startingPayment)
      this.updateSliderVal(startingPayment)
  }

  static getDerivedStateFromProps(newProps, oldState) {
    let { desiredPayment, startingPayment, paymentRange } = newProps,
      sliderVal =
        startingPayment !== oldState.startingPayment
          ? startingPayment
          : desiredPayment

    return oldState.isDragging
      ? oldState
      : {
          ...oldState,
          startingPayment,
          sliderVal,
          paymentRange: paymentRange,
        }
  }

  render() {
    let {
        desiredPayment,
        startingPayment,
        vehicleId,
        quoteId,
        sliderMarks,
        //onChange = () => {},
      } = this.props,
      { isDragging, sliderVal, paymentRange } = this.state,
      qvVal = isDragging ? sliderVal : desiredPayment || startingPayment

    return (
      <div className="slider-wrapper">
        <div className="slider">
          <span className="desired-payment-wrapper">
            <QV
              id={quoteId}
              vehicleId={vehicleId}
              value={qvVal}
              valueKey="desiredPayment"
              type="moneyShort"
              permit="customize"
              onChange={this.updateAppState}
            />{' '}
            <span className="desired-payment-label">per month</span>
          </span>

          <RCSlider
            min={paymentRange[0]}
            max={paymentRange[1]}
            marks={sliderMarks}
            value={this.state.sliderVal}
            onChange={this.updateSliderVal}
            onBeforeChange={() => this.setDragging(true)}
            onAfterChange={v => {
              this.setDragging(false)
              this.updateAppState(v)
            }}
          />
        </div>
      </div>
    )
  }
}

function mapStateToProps(state, op) {
  let mode = getQuoteValue(state, op.vehicleId, op.quoteId, 'mode'),
    startingPayment = getBestPayment(state, op.vehicleId, op.quoteId, mode),
    desiredPayment = getQuoteValue(
      state,
      op.vehicleId,
      op.quoteId,
      'desiredPayment',
    ),
    paymentRange = getPaymentRange(state, op.vehicleId, op.quoteId, op.filters),
    sliderMarks = getPaymentSliderMarkers(
      state,
      op.vehicleId,
      op.quoteId,
      op.filters,
    )

  return {
    ...op,
    mode,
    startingPayment: desiredPayment || startingPayment,
    desiredPayment,
    paymentRange,
    sliderMarks,
    selectedDown: getQuoteValue(state, op.vehicleId, op.quoteId, 'down'),
    selectedCreditScore: getQuoteValue(
      state,
      op.vehicleId,
      op.quoteId,
      'creditScore',
    ),
    creditTiers: getQuoteValue(
      state,
      op.vehicleId,
      op.quoteId,
      'creditTiers',
      {},
    ),
    zipCode: getQuoteValue(state, op.vehicleId, op.quoteId, 'customerZipCode'),
  }
}

export default connect(
  mapStateToProps,
  { updateQuoteSlider },
)(Slider)
